import { choiceBtnSelected, choiceBtnUnselected } from 'components/Profile/helper';

export const getInitialValues = (attributes: any) => {
  return {
    active: attributes?.active ?? true,
    enter_manually: true,
    upload_card: Boolean(attributes?.card_front_pic || attributes?.card_back_pic),
    policy_holder: attributes?.policy_holder || 'myself',
    insurance_company_id: attributes?.insurance_company?.data?.id || '',
    plan_type: attributes?.plan_type || '',
    member_id: attributes?.member_id || '',
    group_number: attributes?.group_number || '',
    card_front_pic: attributes?.card_front_pic || '',
    card_back_pic: attributes?.card_back_pic || ''
  }
}

export const POLICY_HOLDER_LABELS = {
  myself: 'Myself',
  spouse_partner: 'Spouse / Partner',
  parent_guardian: 'Parent / Guardian',
  someone_else: 'Someone else'
}

export const PLAN_TYPE_LABELS = {
  ppo: 'PPO',
  hmo: 'HMO',
  dhmo: 'DHMO',
  epo: 'EPO',
  indemnity: 'Indemnity',
  discount: 'Discount'
}

export const policyHolders = Object.entries(POLICY_HOLDER_LABELS).map(([title, label]) => ({ title, label }))

export const insurancePlanTypes = Object.entries(PLAN_TYPE_LABELS).map(([value, label]) => ({ value, label }))

export const planDetailMethods = [
  {
    name: 'enter_manually',
    label: 'Type in the details',
    description: 'Carrier, member ID, group number'
  },
  {
    name: 'upload_card',
    label: 'Upload a photo of my card',
    description: "Front and back — we'll read it for you"
  }
]

export const choiceBtnClass = (isSelected: boolean) =>
  `btn rounded-xl ${isSelected ? choiceBtnSelected : choiceBtnUnselected}`;

const typedInFields = ['policy_holder', 'insurance_company_id', 'plan_type', 'member_id', 'group_number'];
const cardPicFields = ['card_front_pic', 'card_back_pic'];

export const formatPayload = (values: any) => {
  const formData = new FormData();

  if (!values.active) {
    formData.append('active', 'false');
    return formData;
  }

  formData.append('active', 'true');

  if (values.enter_manually)
    typedInFields.forEach((key) => formData.append(key, values[key]));

  if (values.upload_card)
    cardPicFields.forEach((key) => {
      if (values[key] instanceof File)
        formData.append(key, values[key]);
    });

  return formData;
};
